import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentsEmptyState = () => /*#__PURE__*/_jsx(Flex, {
  justifyContent: "center",
  paddingBlockStart: "1000",
  children: /*#__PURE__*/_jsxs(Flex, {
    maxInlineSize: "660px",
    "data-selenium-test": "documents-index-empty-state",
    gap: "500",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      flexBasis: "300px",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emptyState.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "emptyState.description"
        })
      })]
    }), /*#__PURE__*/_jsx(Illustration, {
      name: "documents",
      width: "50%",
      maxBlockSize: "180px"
    })]
  })
});
export default DocumentsEmptyState;